<vwui-header>
    {{ 'APPLICATION.welcome' | translate }}
</vwui-header>
